import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { LOADING_END, LOADING_START } from "../../../lib/redux/slices/appSlice";

export const getInspectionKeys = createAsyncThunk(
  "GET_INSPECTION_KEYS",
  async (d, { dispatch }) => {
    dispatch(LOADING_START());
    const { data, status } = await axios.get("inspectkeys/");
    dispatch(LOADING_END());
    return { data, status };
  }
);
